import { Block } from "@components/block";
import { EllipsisText } from "@components/ellipsis-text";
import { Config, Table } from "@components/table";
import { useAdminUsers } from "@features/admin/users";
import { ReferralDetails, LeadUserInfo } from "@features/admin/users/api";
import styles from "../selectedUser.module.scss";
import { formatDate } from "@helpers/date";

const config: Config<ReferralDetails> = [
  {
    label: "Id",
    source: "referral_id",
    renderComponent: (data) => (
      <EllipsisText text={data} startLength={10} endLength={10} copy />
    ),
  },
  { label: "Email", source: "referral_email" },
  {
    label: "linked_date",
    source: "linked_date",
    renderComponent: (data) => formatDate(new Date(data)),
  },
  { label: "pay_in", source: "earned_from_pay_in" },
  { label: "pay_out", source: "earned_from_pay_out" },
  { label: "total", source: "total_earned" },
];

export const LeadBlock = () => {
  const { state } = useAdminUsers();
  return (
    <Block className={styles.block}>
      <Table
        title="Users"
        config={config}
        data={(state.userInfo as unknown as LeadUserInfo).referral_details}
      />
    </Block>
  );
};
